export default "__VITE_ASSET__nhGNUuzO__"